import { onMounted as d, watch as i } from "vue";
function s(t, n, r, a) {
  d(
    () => i(
      a,
      (e) => {
        e ? document.body.addEventListener("keydown", o) : document.body.removeEventListener("keydown", o);
      },
      {
        immediate: !0
      }
    )
  );
  function o(e) {
    switch (e.code) {
      case "ArrowLeft":
        n();
        break;
      case "ArrowRight":
        t();
        break;
      case "Escape":
        r();
        break;
    }
  }
}
export {
  s as useKeyboardNavigation
};
